import Button from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import InputTags from "common/components/InputTags/InputTags"
import Modal from "common/components/Modal/Modal"
import { isValidEmail } from "common/utils/formValidations"
import { excelToJsonEmails } from "features/Importar/utils/index"
import UserService from "features/User/services/UserService"
import { AnimatePresence, motion } from "framer-motion"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import "./SendBusinessInvitation.scss"

const SendBusinessInvitation = ({
  visible,
  setInvitation,
  showCompleteModal,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const userService = new UserService()
  const [tags, setTags] = useState([])
  const [showMore, setShowMore] = useState(false)
  const [acceptPolicy, setAcceptPolicy] = useState(false)
  const [addTagTrigger, setAddTagTrigger] = useState(false)

  const handleOnDrop = async (files: $TSMigrationFixMe) => {
    if (!files.length) return
    const urlResource = await excelToJsonEmails(files[0])
    const emailsFiltered = urlResource.filter((email) =>
      // @ts-expect-error TS(2339): Property 'text' does not exist on type '{}'.
      email.text.includes("@")
    )
    // @ts-expect-error TS(2339): Property 'text' does not exist on type '{}'.
    const emailList = emailsFiltered.map((email) => email.text)
    // @ts-expect-error TS(2339): Property 'text' does not exist on type 'never'.
    const filterRepeatedEmails = tags.map((email) => email.text)

    emailList.forEach((elemento) => {
      if (!filterRepeatedEmails.includes(elemento)) {
        filterRepeatedEmails.push(elemento)
      }
    })
    const formattEmailList = filterRepeatedEmails.map((email) => ({
      id: Math.random(),
      text: email,
    }))

    // @ts-expect-error TS(2345): Argument of type '{ id: number; text: $TSFixMe; }[]' is...
    setTags([...formattEmailList])
  }

  const handleSendInvitation = () => {
    setAddTagTrigger(true)
  }

  const onAutoSend = async (newTags = []) => {
    // @ts-expect-error TS(2339): Property 'text' does not exist on type 'never'.
    const emails = newTags.map((tag) => tag.text)
    await userService.sendUserInvitation(emails)
    showCompleteModal(false)
    setAcceptPolicy(false)
    setShowMore(false)
    setInvitation(false)
    setTags([])
  }

  return (
    <Modal
      header={`${t("sendBusinessInvitation.header")}`}
      closable={false}
      size='normal'
      visible={visible}
    >
      <div className='w-100 d-flex flex-column'>
        <p>{t("sendBusinessInvitation.text")}</p>

        <form action=''>
          <div className='mb-2'>
            <span>{t("sendBusinessInvitation.labelMail")}</span>
            <InputTags
              id='emails'
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              onChange={() => {}}
              isValidTagFn={isValidEmail}
              placeholder={`${t("sendBusinessInvitation.placeholderMail")}`}
              errorMessage={`${t("sendBusinessInvitation.errorMsgMail")}`}
              tags={tags}
              setTags={setTags}
              addTagTrigger={addTagTrigger}
              setAddTagTrigger={setAddTagTrigger}
              onAutoSend={onAutoSend}
            />

            <p className='mt-4 modal-subtitle'>
              {t("sendBusinessInvitation.labelMasiveSend")}
            </p>
            <p className='mt-2 mb-2'>
              {t("sendBusinessInvitation.textMasiveSend")}
            </p>
            <Dropzone
              maxFiles={1}
              onDrop={handleOnDrop}
              acceptLabel='.xlsx'
              accept='.xlsx'
              lite
            />
            <label className='mt-4 d-flex'>
              <input
                className='mr-2 invitation-conditions-checker'
                type='checkbox'
                checked={acceptPolicy}
                onChange={() => setAcceptPolicy(!acceptPolicy)}
              />
              <span>
                {t("sendBusinessInvitation.legalText")}{" "}
                {!showMore ? (
                  <span
                    onClick={() => setShowMore(!showMore)}
                    className='link-conditions'
                  >
                    {t("sendBusinessInvitation.legalTextMore")}
                  </span>
                ) : (
                  ""
                )}
                {showMore ? (
                  <AnimatePresence>
                    <motion.div
                      initial='hidden'
                      animate='visible'
                      exit='exit'
                      className='mb-4 tags-container'
                    >
                      <AnimatePresence>
                        <span>
                          <br />
                          {t("")}
                          {t("sendBusinessInvitation.seeMore.textOne")}{" "}
                          <a
                            target='_blank'
                            href='https://finanedi.es/proteccion-datos.html'
                            rel='noreferrer'
                          >
                            {t("sendBusinessInvitation.seeMore.linkOne")}.
                          </a>
                          {t("sendBusinessInvitation.seeMore.textTwo")}
                          <a
                            target='_blank'
                            href='https://finanedi.es/aviso-legal.html'
                            rel='noreferrer'
                          >
                            {t("sendBusinessInvitation.seeMore.linkTwo")}
                          </a>
                        </span>
                      </AnimatePresence>
                    </motion.div>
                  </AnimatePresence>
                ) : (
                  ""
                )}
              </span>
            </label>

            <section>
              <div className='mt-2 mr-1 row justify-content-end align-items-center'>
                <button
                  onClick={() => {
                    showCompleteModal(false)
                    setAcceptPolicy(false)
                    setShowMore(false)
                    setInvitation(false)
                    setTags([])
                  }}
                  type='button'
                  className='mr-2 large cancel-button'
                >
                  {t("sendBusinessInvitation.cancelButton")}
                </button>
                <Button
                  disabled={!acceptPolicy}
                  type='button'
                  className='tw-px-6 tw-py-3 !tw-bg-primary'
                  onClick={() => {
                    handleSendInvitation()
                  }}
                >
                  {t("sendBusinessInvitation.sendButton")}
                </Button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default SendBusinessInvitation
